import React, { useEffect } from "react";
import parser from "html-react-parser";
import Accordion from "@/components/Accordion";
import Aside from "@/components/Aside";
import Bookmark from "./Bookmark";
import Button from "@/components/Button";
import Cards from "@/components/Cards";
import DividerBar from "@/components/DividerBar";
import Heading from "@/components/Heading";
import InlineImage from "@/components/Image";
import Tabs from "@/components/Tabs";
import Text from "@/components/Text";
import TextWithAside from "@/components/TextWithAside";

const TabItemContent = ({
  index,
  text,
  activeTab,
  linkToButtonReplacementWords,
  accordionHtmlHack,
  nested,
  menu,
}) => {
  if (linkToButtonReplacementWords) {
    const replacement = linkToButtonReplacementWords.split(",");
    replacement.forEach((element) => {
      const regex = new RegExp(`>${element.trim()}`, "gi");
      text = text.replace(regex, ` class="button small"/>${element}`);
    });
  }

  if (accordionHtmlHack) {
    text = text.replace(
      /(<ul class="accordion tps-accordion)/gm,
      `$1 htmlhack`
    );
  }

  return (
    <div
      className={`tabs-panel ${
        activeTab === `#panel-${index}` ? " is-active" : ""
      }`}
      id={`panel-${index}`}
      role="tabpanel"
      aria-labelledby={`panel-${index}-label`}
    >
      {parser(text)}

      {nested?.data?.attributes.components.length &&
        nested?.data?.attributes?.publishedAt !== null && (
          <>
            {nested.data.attributes.components?.map((c, index) => {
              switch (c.__component) {
                case "page.text":
                  return (
                    <Text
                      key={index}
                      text={c?.text}
                      withinContainer={c?.withinContainer}
                      displayAsInlineBlock={c?.displayAsInlineBlock}
                      accordionHtmlHack={c?.accordionHtmlHack}
                    />
                  );
                case "page.text-with-aside":
                  return (
                    <TextWithAside
                      key={index}
                      text={c?.text}
                      asides={c?.asides}
                    />
                  );
                case "page.bookmark":
                  return <Bookmark key={index} name={c.name} />;
                case "page.divider-brick":
                  return (
                    <DividerBar
                      key={index}
                      size={c.size}
                      withoutMargins={c.withoutMargins}
                    />
                  );
                case "page.button":
                  return (
                    <Button
                      align={c.align}
                      buttonClasses={c?.buttonClasses}
                      buttonColor={c?.buttonColor}
                      buttonLarge={c?.buttonLarge}
                      buttonsPositioning={c?.buttonsPositioning}
                      contentBefore={c?.ContentBefore}
                      filled={c?.filled}
                      key={index}
                      menu={menu}
                      news={c?.news}
                      page={c?.page}
                      concert={c?.concert}
                      course={c?.course}
                      targetBlank={c?.targetBlank}
                      text={c.text}
                      url={c.url}
                      withinContainer={c?.withinContainer}
                    />
                  );
                case "page.accordion":
                  return (
                    <Accordion
                      id={index}
                      key={index}
                      title={c.title}
                      items={c.items}
                      cardItems={c.cards}
                      menu={menu}
                      slideEffect={c.slideEffect}
                    />
                  );
                case "page.cards":
                  return (
                    <Cards
                      cardsAlignCenter={c?.cardsAlignCenter}
                      cardsText={c?.cardsText}
                      cardsTitle={c.cardsTitle}
                      cardsTitleAlign={c?.cardsTitleAlign}
                      cardsTitleHeadingLevel={c?.cardsTitleHeadingLevel}
                      items={c.items}
                      key={index}
                      layout={c.layout}
                      menu={menu}
                      numTileColumns={c?.numTileColumns}
                      withinContainer={c?.withinContainer}
                    />
                  );
                case "page.tabs":
                  return (
                    <Tabs
                      title={c.title}
                      tabsId={c.tabsId}
                      items={c.elements}
                      key={index}
                    />
                  );
                case "page.heading":
                  return (
                    <Heading
                      alignTitle={c?.alignTitle}
                      hTitleLevel={c?.hTitleLevel}
                      hTitleSeparator={c?.hTitleSeparator}
                      key={index}
                      title={c?.title}
                      subtitle={c?.subtitle}
                      subtitleLevel={c?.subtitleLevel}
                      withinContainer={c?.withinContainer}
                    />
                  );
                case "page.image":
                  return (
                    <InlineImage
                      image={c?.image?.data?.attributes}
                      key={index}
                      alignment={c?.alignment}
                      size={c?.size}
                      style={c?.style}
                    />
                  );
                case "page.aside-block":
                  return (
                    <Aside
                      key={index}
                      alignAside={c?.alignAside}
                      nested={c?.nested}
                      menu={menu}
                    />
                  );
                default:
                  return null;
              }
            })}
          </>
        )}
    </div>
  );
};

export default TabItemContent;
